module.exports = __webpack_public_path__ + "media/images/conlance_logo_gray-e3ceea84a3cd812daf9f79b5f9a64092.svg";